// Opens the Save to list sheet (DEV-51010) from anywhere on the engineer
// side: the "Add to list" toast action after a heart, and the "List"
// button on favourite rows. The sheet itself is mounted once by
// SaveToListProvider in EngineerRoutes.
import { createContext, useContext } from 'react'

export interface SaveToListTarget {
  favouriteId: string
  /** Shown under the sheet's title so the engineer knows what they're filing. */
  productName: string
}

export interface SaveToListContextValue {
  openSaveToList: (target: SaveToListTarget) => void
}

export const SaveToListContext = createContext<SaveToListContextValue | null>(null)

export function useSaveToList(): SaveToListContextValue {
  const context = useContext(SaveToListContext)
  if (!context) {
    throw new Error('useSaveToList must be used within SaveToListProvider')
  }
  return context
}
